import { useMutation } from '@tanstack/react-query';
import { setAttachmentLocation } from '../../TimesheetsService';

const usePatchAttachmentLocation = (options = {}) => useMutation(setAttachmentLocation, options);

export default usePatchAttachmentLocation;
